import {HeadingPlugin} from "@platejs/basic-nodes/react";
import {BlockquotePlugin} from "@platejs/basic-nodes/react";
import {BoldPlugin, ItalicPlugin, CodePlugin} from "@platejs/basic-nodes/react";
import {ListPlugin} from "@platejs/list-classic/react";
import {LinkPlugin} from "@platejs/link/react";
import {HorizontalRulePlugin} from "@platejs/basic-nodes/react";
import {ParagraphPlugin} from "platejs/react";
import {CursorOverlay} from "../CursorOverlay";
import {FloatingLinkEditor} from "../FloatingLinkEditor";
import {isMissingProtocol} from "../../../utils/SchoolBlocksUtilities";
import {capitalize} from "../../../utils/StringUtilities";
import {DocxPlugin} from "@platejs/docx";
import { BlockPlaceholderPlugin } from 'platejs/react';
import styles from "../styles/SlateEditor.module.scss";
import {CursorOverlayPlugin} from "@platejs/selection/react";
import {ExitBreakPlugin} from "platejs";

type attributesToPreserve = "class" | "id" | "style" | "height" | "width" | "alt" | "src" | "title";
export const preserveAttributes: attributesToPreserve[] = ["class", "id", "style", "height", "width", "alt", "src", "title"];

export function attributesToJsx(attributes: Partial<{[key in attributesToPreserve]: any}> = {}) {
    const jsx = {}
    for (let [k, v] of Object.entries(attributes)) {
        switch(k) {
            case "class":
                jsx["className"] = v;
                break;
            case "style":
                jsx["style"] = v.split(",").map(v => v.trim()).reduce((acc, curr) => {
                    const [key, value] = curr.split(":").map(v => v.trim());
                    // convert kebab case to camel case
                    acc[key.split("-").map((w, i) => {
                        return i > 0 ? capitalize(w) : w;
                    }).join("")] = value;
                    return acc;
                }, {})
                break;
            default:
                jsx[k] = v;
        }
    }
    return jsx;
}

export const basePlatePlugins = [
    ParagraphPlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    HeadingPlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    BlockquotePlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    BoldPlugin,
    ItalicPlugin,
    CodePlugin,
    ListPlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    ExitBreakPlugin.configure({
        shortcuts: {
            insert: { keys: 'mod+enter' },
            insertBefore: { keys: 'mod+shift+enter' },
        },
    }),
    LinkPlugin.extend({
        render: { afterEditable: () => <FloatingLinkEditor />},
        options: {
            transformInput: (url) => {
                if (isMissingProtocol(url)) {
                    url ="https://" + url;
                }
                return url;
            },
            parsers: {
                html: {
                    deserializer: {
                        attributeNames: preserveAttributes,
                    }
                }
            }
        }
    }),
    HorizontalRulePlugin,
    CursorOverlayPlugin.configure({
        render: ({afterEditable: () => <CursorOverlay />})
    }),
    DocxPlugin,
    BlockPlaceholderPlugin.configure({
        options: {
            className: styles.paragraphPlaceholder,
        },
    }),
];
